import $ from 'jquery';

const modalTemplate = require('./view/modal.handlebars');
const BASE_SELECTOR: string = '[data-modal]';
const MODAL_SELECTOR: string = '.fancy-modal';

export class ModalUI {
    public constructor(private $base: HTMLElement) {
        $base.setAttribute('data-modal-added', 'true');
    }
    
    public show() {
        $('body').find('.fancy-modal').addClass('is-open');
    }
    
    public hide() {
        this.reInit();
        $('body').find('.fancy-modal').removeClass('is-open');
    }
    
    /**
     * Open the Modal
     * @param callback
     */
    public onOpen(callback: () => {}) {
        $(this.$base).on('click', () => {
            callback();
        });
    }
    
    /**
     * Close the Modal
     * @param callback method
     */
    public onClose(callback: ()  => {}) {
        $('.fancy-modal__close').on('click', () => {
            callback();
        });
        
        $(document).on('keydown', (event) => {
            if (event.key === 'Escape') {
                callback();
            }
        });
    }
    
    /**
     * Add the wrapper HTML into the DOM
     */
    public init() {
        $('body').append(modalTemplate());
    }
    
    /**
     * Add the wrapper HTML into the DOM
     */
    public reInit() {
        $('body').find('.fancy-modal').remove();
        $('body').append(modalTemplate());
    }
    
    /**
     * Check if the wrapper inside the DOM
     */
    public countInit(): number {
        return $(MODAL_SELECTOR).length;
    }
    
    /**
     * Render the passed template
     */
    public render(template) : void {
        $('body').find('.fancy-modal__content').html(template());
    }
    
    /**
     * Read the data attribute
     */
    public readData() {
        return {...$(this.$base).data('modal'), target: this.$base};
    }
}

export function createModalUIinstances(): ModalUI[] {
    const elements = $(BASE_SELECTOR);
    let instances: ModalUI[] = [];
    
    elements.each((index, el) => {
        if (!el.hasAttribute('data-modal-added')) {
            instances.push(new ModalUI(el));
        }
    });
    return instances;
}
